import HomePage from './category/homepage';
import ForYou from './category/foryou';
import Ticker from './category/ticker';
import CaseStudy from './category/caseStudy';
import Updates from './category/updates';
import Analysis from './category/analysis';
import Qna from './category/qna';
import HalamanSaham from './category/halamanSaham';
import Notification from './category/notification';
import Profile from './category/profile';
import Other from './category/other';
import LoginRegister from './category/loginRegister';

const Analytics = {
  HomePage,
  ForYou,
  Ticker,
  CaseStudy,
  Updates,
  Analysis,
  Qna,
  HalamanSaham,
  Notification,
  Profile,
  Other,
  LoginRegister,
};

export default Analytics;
